/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum SessionInputDataTypeCardsEnum {
  "cards" = "cards"
}

/**
 * Discriminator used to identify session input data for cards onboarding
 */

export type SessionInputDataTypeCards = t.TypeOf<
  typeof SessionInputDataTypeCards
>;
export const SessionInputDataTypeCards = enumType<
  SessionInputDataTypeCardsEnum
>(SessionInputDataTypeCardsEnum, "SessionInputDataTypeCards");
